import qz from "qz-tray";
import ApiService from "../../utils/ApiService";
import {
  PUBLIC_CERT_DEVELOPMENT,
  PUBLIC_CERT_LOCAL,
  PUBLIC_CERT_PRODUCTION,
  PUBLIC_CERT_STAGE,
} from "../../constant/qz-tray-certificates";

const getSignedInData = async (toSign) => {
  try {
    const res = await ApiService.QZ_TRAY_MESSAGE_SIGN_IN({ data: toSign }, "");

    const { data } = res.payload;

    return {
      success: true,
      data,
      message: "",
    };
  } catch (err) {
    console.error("Failed to Signedin Data. Error: ", err);

    return {
      success: false,
      message: err.message,
      data: "",
    };
  }
};
// Initialize QZ Tray and security
export const initQZTray = async () => {
  try {
    // Connect to QZ Tray if not already connected
    if (qz.websocket.isActive()) {
      console.log("QZ socket is active.");
      return;
    }

    console.log("----QZ socket not active. Activating process started...................");
    console.log("--------Sign in process started-------------------------");
    // Set public certificate (trusted by QZ Tray)
    let publicCert = PUBLIC_CERT_LOCAL;

    if (process.env.REACT_APP_NODE_ENV === "development") {
      publicCert = PUBLIC_CERT_DEVELOPMENT;
    } else if (process.env.REACT_APP_NODE_ENV === "stage") {
      publicCert = PUBLIC_CERT_STAGE;
    } else if (process.env.REACT_APP_NODE_ENV === "production") {
      publicCert = PUBLIC_CERT_PRODUCTION;
    }

    console.log("*************publicCert===========", { publicCert });

    qz.security.setCertificatePromise((resolve, reject) => {
      resolve(publicCert);
    });

    // Set signature handler to call your backend API
    qz.security.setSignaturePromise(async (toSign) => {
      const signedInResult = await getSignedInData(toSign);

      console.log("*************signedInResult*************", { signedInResult });

      if (!signedInResult.success) {
        console.log("----QZ signed in failed. Error:", signedInResult.message);
        return;
      }

      return signedInResult.data;
    });

    console.log("---connecting to Qz tray web socket----");
    // qz.websocket.setReconnectAttempts(-1); // Number of times to retry
    // qz.websocket.setReconnectDelay(3000); // Delay between attempts in ms
    // Handle when connection closes
    qz.websocket.setClosedCallbacks(() => {
      console.warn("QZ Tray connection closed, retrying...");

      setInterval(() => {
        if (!qz.websocket.isActive()) {
          initQZTray();
        }
      }, 5000); // Check every 5 seconds
    });

    // Handle connection errors
    qz.websocket.setErrorCallbacks((err) => {
      console.error("QZ Tray connection error:", err);
    });

    await qz.websocket.connect();

    console.log("---connected to Qz tray web socket----");
  } catch (error) {
    console.log("You do not have installed QZ tray printing service. Please, install it.", { error });
  }
};
